import 'babel-polyfill'
import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import router from '@/router'
import store from '@/store/store'

Vue.config.productionTip = false

// in this file
import config from '@/config'

// root component
import App from '@/App.vue'

// import for side effects
import '@/api'
import '@/components/global'
import '@/directives/directive-visible'
import '@/filters/filter-datetime'
import '@/filters/filter-number'
import '@/filters/filter-url'

// import last to override hubsolv-ui theme]
// @ts-ignore
import('@/stylesheets/stylus/theme.styl').then(() => {
    cssVars({})
})

// Moment.js
import * as moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
momentDurationFormatSetup(moment)

// vue-autosize
import VueAutosize from 'vue-autosize'
Vue.use(VueAutosize)

// v-tooltip
import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
    defaultDelay: {
        show: config.UI.TOOLTIP_SHOW_DELAY_IN_MILLISECONDS,
        hide: config.UI.TOOLTIP_HIDE_DELAY_IN_MILLISECONDS,
    },
    defaultBoundariesElement: 'viewport',
})

// PortalVue
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

// Vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// VueMq
import VueMq from 'vue-mq'
Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
      sm: 500,
      md: 800,
      lg: 1500,
      xl: Infinity,
    },
    defaultBreakpoint: 'sm', // customize this for SSR
})

// Disable console.log when in production.
if (process.env.NODE_ENV === 'production') {
    console.log = () => {}
    console.error = () => {}
    console.group = () => {}
    console.groupCollapsed = () => {}
    console.groupEnd = () => {}
}


Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

//@ts-ignore
if (window.Cypress) {
    //@ts-ignore
    window.app = app
}
